<template>
  <div id="results" class="container">
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>搜索结果(数量{{count_number}})</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="box" style="font-size:13px;" id="box">
      <div class="under-line">
        <div>
          <el-row style="display:flex">
            <div style="background:rgba(238,238,238,1);" class="title1">品牌:</div>
            <el-col style="padding-top:10px" :span="23">
              <div class="lv3Text empty" v-if="currentBrands.length==0">没有相关的品牌</div>
              <div
                style="height:50px;overflow:hidden;margin-bottom:10px;"
                v-if="currentBrands.length>0&&!showMore"
              >
                <el-row>
                  <el-col :span="22" style="padding-left:15px">
                    <div>
                      <span
                        :class="brand == item.name?'active': ''"
                        class="item1"
                        v-for="(item,index) in currentBrands"
                        :key="index"
                        @click="setBand(item.name)"
                        @mouseenter="coverId=item.id"
                        @mouseleave="coverId=0"
                      >
                        <div>
                          <figure class="imghvr-fade" style="background-color:#fff;">
                            <img
                              :src="serve+item.logo_thumb"
                              class="bCover"
                              :class="brand==item.name?'active':''"
                            />
                            <figcaption
                              style="border:1px solid #e2211c;background-color:#fff;color:#e2211c;line-height:50px;text-align:center;padding:0"
                            >{{item.name}}</figcaption>
                          </figure>
                        </div>
                      </span>
                    </div>
                  </el-col>
                  <el-col :span="2" align="right">
                    <div style="margin-right:10px;">
                      <span
                        v-if="currentBrands.length>8&&!showMore"
                        @click="showMore=true"
                        style="cursor: pointer;"
                      >
                        更多
                        <i class="fas fa-angle-down fa-lg" style="margin-left:5px"></i>
                      </span>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <div v-if="showMore">
                <el-row>
                  <el-col :span="22" style="padding-left:15px">
                    <div style="height:120px;overflow-y: scroll;">
                      <span
                        :class="brand == item.name?'active': ''"
                        class="item1"
                        v-for="(item,index) in currentBrands"
                        :key="index"
                        @click="setBand(item.name)"
                        @mouseenter="coverId=item.id"
                        @mouseleave="coverId=0"
                      >
                        <div>
                          <figure class="imghvr-fade" style="background-color:#fff;">
                            <img
                              :src="serve+item.logo_thumb"
                              class="bCover"
                              :class="brand==item.name?'active':''"
                            />
                            <figcaption
                              style="border:1px solid #e2211c;background-color:#fff;color:#e2211c;line-height:50px;text-align:center;padding:0"
                            >{{item.name}}</figcaption>
                          </figure>
                        </div>
                      </span>
                    </div>
                  </el-col>
                  <el-col :span="2" align="right">
                    <div style="margin-right:10px;">
                      <span v-if="showMore" @click="showMore=false" style="cursor: pointer;">
                        收起
                        <i class="fas fa-angle-up fa-lg" style="margin-left:5px"></i>
                      </span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>

        <div style="border-top: 1px solid #ddd;border-bottom: 1px solid #ddd">
          <el-row style="display:flex">
            <div style="background:rgba(238,238,238,1);" class="title1">货期:</div>
            <el-col :span="23" style="padding-left:15px">
              <div style="padding:15px 0;">
                <!-- <span :class="validity==null?'active': ''" class="item1" @click="setV(null)">不限</span> -->
                <span
                  :class="validity==item?'active': ''"
                  class="item1"
                  v-for="(item,index) in vArray"
                  :key="index"
                  @click="setV(item)"
                  style="margin-right:10px"
                >{{item}}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="class1">
          <el-row style="display:flex">
            <div style="background:rgba(238,238,238,1);" class="title1">分类:</div>
            <el-col :span="23" style="padding-left:15px">
              <div v-if="allCount[0]" style="padding-top:10px">
                <el-tabs v-model="activeClass" type="card" @tab-click="handleClick" class="tab">
                  <el-tab-pane
                    v-for="(item,index) of topClass"
                    :key="index"
                    :label="item.title+'('+topCount[index]+')'"
                    :name="item.id"
                  >
                    <span
                      class="item1"
                      :class="[class_name2==item.id?'active':'',item.count>0?'':'hide']"
                      v-for="(item,index) in secondClass"
                      :key="index"
                      @click="getClass3(item.id)"
                      style="margin-right:10px;margin-bottom:5px;"
                    >
                      <span>{{item.cate_name}}({{item.count}})</span>
                    </span>
                    <div
                      style="border-top:1px solid #ddd;padding-top:10px;"
                      v-if="class_name2!=null"
                    >
                      <span
                        class="item1"
                        :class="class_name3==item.id?'active':''"
                        v-for="(item,index) in thirdClass"
                        :key="index"
                        @click="setClass3(item.id)"
                        style="margin-right:10px;margin-bottom:5px"
                      >{{item.cate_name}}</span>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="box box1" style="margin-top: 20px;">
      <div style="width:1040px">
        <div class="options">
          <el-row :gutter="5" style="line-height:17px;">
            <el-col :span="3">
              <div align="left" style="padding-left:20px;">
                <el-radio-group v-model="display" size="mini">
                  <el-tooltip class="item" effect="light" content="转为列表" placement="bottom">
                    <el-radio-button label="1">
                      <i class="fas fa-list"></i>
                    </el-radio-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="light" content="转为矩阵图" placement="bottom">
                    <el-radio-button label="2">
                      <i class="fas fa-th"></i>
                    </el-radio-button>
                  </el-tooltip>
                </el-radio-group>
              </div>
            </el-col>
            <el-col :span="13">
              <el-radio-group v-model="orderBy" size="mini">
                <el-radio-button label="1">
                  综合
                  <i class="fas fa-long-arrow-alt-down" style="font-size:14px"></i>
                </el-radio-button>
                <el-radio-button label="5">
                  销量
                  <i class="fas fa-long-arrow-alt-down" style="font-size:14px"></i>
                </el-radio-button>
                <el-radio-button label="2">
                  人气
                  <i class="fas fa-long-arrow-alt-down" style="font-size:14px"></i>
                </el-radio-button>
                <el-radio-button label="3">
                  价格从低到高
                  <i class="fas fa-long-arrow-alt-down" style="font-size:14px"></i>
                </el-radio-button>
                <el-radio-button label="4">
                  价格从高到低
                  <i class="fas fa-long-arrow-alt-down" style="font-size:14px"></i>
                </el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col :span="7">
              <div align="right" class="s">
                <el-checkbox v-model="is_available" true-label="1" false-label="0">仅显示有货商品</el-checkbox>
                <el-checkbox v-model="is_special" true-label="1" false-label="0">仅显示打折商品</el-checkbox>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-if="ready&&total==0" align="center" class="none_shop">
          <div>
            <div class="none_btn">
              <el-button @click="serve_din" type="primary" size="medium">服务定制</el-button>
              <el-button type="primary" style="margin:0 30px 0 40px" size="medium">试剂定制</el-button>
              <el-button type="primary" size="medium">抗体定制</el-button>
            </div>
            <object
              :data="serve + '/images/search_engine.svg'"
              type="image/svg+xml"
              style="width:20%;"
            ></object>
            <div
              class="lv4Text"
              style="margin-top:20px;color:#e2211c;width:500px;line-height:20px"
            >抱歉，没有找到“{{keywords}}，{{suolabel}}”相关的商品，请致电400-821-3401，联系客服咨询，或发送邮件至srm@bioflin.com客服邮箱，我们会尽快回复</div>
          </div>
          <div class="none_editor">
            <div>
              <img style="width: 120px; height:120px" :src="serve + service" alt />
              <!-- <el-image style="width: 100px; height: 100px"  :fit="fit"></el-image> -->
              <span>宝枫林24h客服</span>
            </div>
            <div>
              <img style="width: 120px;height:120px" :src="serve + appCode" alt />
              <span>手机app</span>
            </div>
            <div>
              <img style="width: 120px;height:120px" :src="serve + gzhCode" alt />
              <span>宝枫林公众号</span>
            </div>
            <div>
              <img style="width: 120px;height:120px" :src="serve + miniCode" alt />
              <span>宝枫林小程序</span>
            </div>
          </div>
        </div>
        <div v-if="!ready" align="center" style="padding:50px 0">
          <pulse-loader color="#e2211c"></pulse-loader>
        </div>
        <div v-if="display == 1&&ready&&total>0">
          <template>
            <el-table
              :data="tableData"
              row-class-name="tRow"
              style="width: 100%;"
              header-row-class-name="tHeader"
            >
              <el-table-column align="center" width="90" label="图片">
                <template slot-scope="scope">
                  <img style="width: 74px; height: 74px" v-lazy="serve+scope.row.images " />
                </template>
              </el-table-column>
              <el-table-column label="商品详情">
                <template slot-scope="scope">
                  <div style="height:5.3em;over-flow:hidden" class="tTitle">
                    <router-link :to="'/product/'+scope.row.id">
                      <span v-html="brightenKeyword(scope.row.title,keywords)"></span>
                    </router-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="货号" width="120" v-if="tableType!=7&&tableType!=9">
                <template slot-scope="scope">
                  <div class="lv3Text" align="center">{{scope.row.item_no}}</div>
                </template>
              </el-table-column>
              <el-table-column label="品牌" width="125" v-if="tableType<6">
                <template slot-scope="scope">
                  <div class="lv3Text" align="center">{{scope.row.brand}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="animal_age" label="年龄" width="80" v-if="tableType==6"></el-table-column>
              <el-table-column
                prop="uses"
                label="应用"
                v-if="tableType==4||tableType==5||tableType==7||tableType==8"
              ></el-table-column>
              <el-table-column
                prop="specification"
                label="规格/包装"
                width="120"
                align="center"
                v-if="tableType==4||tableType==3||tableType==2||tableType==1"
              ></el-table-column>
              <el-table-column label="评价" width="80" v-if="tableType!=7" align="center">
                <template slot-scope="scope">
                  <el-popover placement="bottom" trigger="hover" width="360">
                    <p style="text-align:center" v-if="comment_type.length == 0">暂无评论</p>
                    <p v-else v-for="items in comment_type" :key="items.index">
                      <span
                        style="font-size:14px;
                  font-family:MicrosoftYaHei;
                  font-weight:400;
                  color:rgba(102,102,102,1);"
                      >{{items.nickname}}</span>
                      :
                      <span
                        style="font-size:14px;
                    font-family:MicrosoftYaHei;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    l"
                      >{{items.content}}</span>
                    </p>
                    <div
                      @mouseover="hover_evaluate(scope.row)"
                      style="cursor: pointer;"
                      class="lv3Text hover_class"
                      slot="reference"
                    >{{scope.row.avg_rank==0?'暂无评分':'评价'}}</div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="货期" width="65" v-if="tableType!=7" align="center">
                <template slot-scope="scope">
                  <div
                    class="lv3Text"
                    style="color:#2EACFF;"
                    v-text="scope.row.leadtime <= 3 ?'现货':scope.row.leadtime+'天'"
                  ></div>
                </template>
              </el-table-column>
              <el-table-column label="市场价" width="75" v-if="tableType!=7" align="center">
                <template slot-scope="scope">
                  <div class="lv3Text">
                    <s>&yen;{{_.toInteger(scope.row.original_price)}}</s>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="售价" width="83" v-if="tableType!=7" align="center">
                <template slot-scope="scope">
                  <div class="lv0Text">&yen;{{scope.row.show_price}}</div>
                </template>
              </el-table-column>
              <el-table-column width="75" label="操作" align="center">
                <template slot-scope="scope">
                  <div align="center">
                    <router-link :to="'/product/'+scope.row.id"  v-if="scope.row.show_price == 0">
                      <el-button
                        type="text"
                        style="color:#2EACFF"
                        class="buy-btn"
                      >询价</el-button>
                    </router-link>
                    <el-button
                      v-else
                      type="text"
                      @click="openCart(_.toInteger(scope.$index),scope.row.id,scope.row.inventory)"
                      style="color:#2EACFF"
                      class="buy-btn"
                    >购买</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div v-if="display == 2&&ready&&total>0" class="dis2 lv2Text">
          <el-row :gutter="20">
            <el-col
              :span="6"
              v-for="(item,index) of tableData"
              :key="index"
              style="margin-bottom:20px"
            >
              <router-link :to="'/product/' + item.id">
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                  <img style="width: 242px; height: 242px" :src="serve+item.images" />
                  <div style="padding: 14px;text-align:left">
                    <div class="bottom clearfix">
                      <el-button
                        type="text"
                        style="font-size:26px"
                        class="button"
                      >&yen;{{item.selling_price}}</el-button>
                    </div>
                    <span class="rectangle_title">{{item.title}}</span>
                  </div>
                </el-card>
              </router-link>
            </el-col>
          </el-row>
        </div>
        <div v-if="ready&&total>0" class="pager" align="center">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="24"
            :current-page="curretnPage"
            @current-change="pageChange"
            hide-on-single-page
          ></el-pagination>
        </div>
      </div>
      <div class="box_right_AD">
        <div class="right_AD_top">
          <span>精选商品</span>
          <span>广告</span>
        </div>
        <div
          class="right_AD_conter"
          style=" margin-bottom: 30px;"
          v-for="items in advertising"
          :key="items.index"
        >
          <div class="right_AD_img">
            <img style="width:120px;height:120px" :src="serve + items.images" />
          </div>
          <p class="right_AD_money">&yen;{{items.selling_price}}</p>
          <router-link
            :to="'/product/' + items.p_id"
            tag="p"
            class="right_AD_money1"
          >{{items.title}}</router-link>
          <div class="right_AD_evaluate">
            <span v-if="items.number!=0">
              已有
              <span style="color:#005288">{{items.number}}+</span>人评价
            </span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="inCartDialog"
      width="250px"
      center
      :show-close="false"
      :modal="false"
      style="margin-top:20vh"
    >
      <div align="center">
        <i class="fas fa-check-circle fa-5x lv0Text"></i>
        <div class="lv0Text" style="font-size:18px;margin: 20px 0;">商品已加入购物车</div>
      </div>
    </el-dialog>

    <el-dialog center title="技术服务定制" :visible.sync="dialogFormVisible">
      <div style="margin:0 0 10px 0">您的联系信息:</div>
      <el-form class="clearfix">
        <el-form-item label="单位" style="float:left" :label-width="formLabelWidth">
          <el-input style="width:260px" v-model="j_unit" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话" style="float:left" :label-width="formLabelWidth">
          <el-input style="width:260px" v-model="j_mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" style="float:left" :label-width="formLabelWidth">
          <el-input style="width:260px" v-model="j_address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" style="float:left" :label-width="formLabelWidth">
          <el-input style="width:260px" v-model="j_concat" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email" style="float:left" :label-width="formLabelWidth">
          <el-input style="width:260px" v-model="j_emali" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <div>研究方案:</div>
      <div style="margin:10px 0 10px 60px">
        <el-input
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          placeholder="请输入内容"
          v-model="textarea1"
        ></el-input>
      </div>
      <div>研究目的:</div>
      <div style="margin:10px 0 10px 60px">
        <el-input
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          placeholder="请输入内容"
          v-model="textarea2"
        ></el-input>
      </div>
      <div>可提供材料:</div>
      <div style="margin:10px 0 10px 60px">
        <el-input
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          placeholder="请输入内容"
          v-model="textarea3"
        ></el-input>
      </div>
      <div>其他:</div>
      <div style="margin:10px 0 10px 60px">
        <el-input
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          placeholder="请输入内容"
          v-model="textarea4"
        ></el-input>
      </div>
      <div style="line-height:30px">
        <div>( 可发至下列邮箱或拨打电话咨询 )</div>
        <div>Tel : 400-812-3401、13311688691</div>
        <div>E-mail : jack@bioflin.com、srm@bioflin.com</div>
        <div>Web : www.bioflin.com</div>
        <div>Add : 上海市徐汇区肇嘉浜路789号均瑶国际广场17楼E3座</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="skil_sunmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import $ from "jquery";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { constants } from "crypto";
export default {
  components: {
    PulseLoader
  },
  data() {
    return {
      formLabelWidth: "100px",
      //

      j_unit: "",
      j_concat: "",
      j_mobile: "",
      j_emali: "",
      j_address: "",
      textarea1: "",
      textarea2: "",
      textarea3: "",
      textarea4: "",
      //
      dialogFormVisible: false,
      serve: this.$store.state.serve,

      appCode: "/wechat/qrCode/appCode.jpg",
      gzhCode: "/wechat/qrCode/gzhCode.jpg",
      miniCode: "/wechat/qrCode/miniCode2.jpg",
      qrCodeIcon: "/wechat/qrCode/qrCodeIcon.jpg",
      service: "/webInfo/official_wx.jpg",
      count_number: 0,
      cartId: 0,
      inCartDialog: false,
      showMore: false,
      num: 1,
      cartItem: {},
      cartDialog: false,
      tableType: 0,
      ready: false,
      secondClass: [],
      vId: null,
      allBrands: {},
      allCount: {},
      currentBrands: {},
      topCount: {},
      thirdClass: [],
      //
      activeClass: "",
      topClassId: null,
      validity: null,
      v: null,
      count: [],
      coverId: 0,
      display: 1,
      orderBy: 1,
      buttonValue: "",
      keywords: this.$route.query.keywords,
      suolabel: "",
      categorys: [],
      categorys2: [],
      categorys3: [],
      c_id1: 0,
      c_id2: null,
      c_id3: null,
      vArray: ["现货", "4-7天", "7-14天", "15-30天", "大于30天"],
      class_name1: "",
      class_name2: "",
      class_name3: "",
      b_value: null,
      b_keys: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "X",
        "Y",
        "Z"
      ],
      order_p: null,
      order_h: 0,
      has: 0,
      onsale: 0,
      brands: null,
      brand: null,
      display: 1,
      tableData: null,
      total: 0,
      curretnPage: 1,
      is_available: "0",
      is_special: "0",
      comment_type: [],
      topClass: [
        {
          title: "耗材",
          id: "1"
        },
        {
          title: "实验办公",
          id: "2"
        },
        {
          title: "试剂",
          id: "3"
        },
        {
          title: "抗体",
          id: "4"
        },
        {
          title: "仪器设备",
          id: "5"
        },
        {
          title: "模式生物",
          id: "6"
        },
        {
          title: "技术服务",
          id: "7"
        },
        {
          title: "软件",
          id: "8"
        },
        {
          title: "书城",
          id: "9"
        },
        {
          title: "生物制药",
          id: "10"
        }
      ],
      advertising: [],
      searchLength: 0,
      P_id: []
    };
  },
  watch: {
    orderBy(value) {
      this.curretnPage = 1;
      this.order_p = null;
      this.order_h = null;
      if (value == 2) {
        this.order_h = 1;
      } else if (value == 3) {
        this.order_p = 1;
      } else if (value == 4) {
        this.order_p = 2;
      }
      this.loadData();
    },
    is_special(v) {
      this.loadData();
    },
    is_available(v) {
      this.loadData();
    }
  },
  created() {
    this.initData();
  },
  activated() {
    this.initData();
    if (this.keywords) {
      this.add_search_history(this.keywords);
    }
  },
  methods: {
    add_search_history(keywords) {
      var formData = {
        mobile: this.$cookies.get("user"),
        keyword: keywords
      };
      this.axios(this.serve + "/add_search_history", { params: formData });
    },
    skil_sunmit() {
      const loading = this.$loading({
        lock: true,
        text: "玩命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)"
      });
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const formData = new FormData();
      formData.append("company", this.j_unit);
      formData.append("link_member", this.j_concat);
      formData.append("phone", this.j_mobile);
      formData.append("email", this.j_emali);
      formData.append("address", this.j_address);
      formData.append("scheme", this.textarea1);
      formData.append("purpose", this.textarea2);
      formData.append("canProvide", this.textarea3);
      formData.append("other", this.textarea4);
      this.axios
        .post(this.serve + "/serveCustomMake", formData, config)
        .then(res => {
          this.dialogFormVisible = false;
          loading.close();
          if (res.data.status == "success") {
            this.$message({
              type: "success",
              message: "操作成功"
            });
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    serve_din() {
      this.dialogFormVisible = true;
    },
    // 筛选变色
    brightenKeyword(val, keyword) {
      var val = val + "";

      if (keyword != "" && keyword != undefined) {
        var keywordArr = keyword.split(" ");
        for (var i in keywordArr) {
          val = val.replace(
            keywordArr[i],
            '<font color="#e2211c">' + keywordArr[i] + "</font>"
          );
        }
        return val;
      } else {
        return val;
      }
    },
    geting(v) {
      this.axios.get(this.serve + "/search_ad").then(res => {
        this.advertising = [];
        for (var key in res.data) {
          this.advertising.push(res.data[key]);
        }
        var x = parseInt(v / 2);
        if (x == 0) {
          this.advertising.splice(0, 9);
        } else {
          this.advertising.splice(0, 10 - x);
        }
      });
    },
    hover_evaluate(v) {
      this.axios
        .get(this.serve + "/get_three_commend", {
          params: {
            p_id: v.id
          }
        })
        .then(res => {
          this.comment_type = [];
          if (res.data.status == "success") {
            for (var key in res.data.data) {
              this.comment_type.push(res.data.data[key]);
            }
          }
        });
    },
    add(id) {
      if (this.$store.state.isLogin) {
        var formData = {
          mobile: that.$cookies.get("user"),
          token: that.$cookies.get("token"),
          id: id,
          number: $("#input-number").val()
        };
        var tableData = this.tableData;
        for (var i in tableData) {
          if (tableData[i].id == id) {
            formData.shop_id = tableData[i].shop_id;
          }
        }
        this.axios
          .get(this.serve + "/member/add_car", {
            params: formData
          })
          .then(res => {
            if (res.data.status == "success") {
              this.$message("商品已加入购物车");
              this.cartDialog = false;
              this.num = 1;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        this.$router.push("/login");
      }
    },
    openCart(index, id, inventory) {
      this.cartId = id;
      $("#add-red").on("click", function() {
        alert("hey it's Sam.");
      });
      $(".row-op").remove();
      $(".el-table__row:eq(" + index + ")").after(
        "<div class='row-op clear'><div class='clear-item r1' style='width:300px'><div>运费</div><div class='lv0Text'>请咨询客服(400-821-3401)</div></div><div class='clear-item r1' style='width:100px'><div>库存</div><div>" +
          inventory +
          "</div></div><div class='clear-item r1' style='width:350px'><div>购买数量</div><div><button class='bt1' id='add-red'>-</button><input value='1' id='input-number' type='text' style='width:30px;margin:0 10px;padding:3px 0 2px 15px;border:1px solid #ddd'><button class='bt1' id='add-btn'>+</button></div></div><div class='clear-item l1'><button class='bt2' id='inCart'>加入购物车</button></div><div class='clear-item l1'><button class='bt2' id='buyNow'>立即购买</button></div><div class='viewMore'><a class='moreLink' href='#/product/" +
          id +
          "'>查看详情>></a></div></div>"
      );
      $("#add-red").bind("click", function() {
        var v = $("#input-number").val();
        v = parseInt(v) - 1;
        if (v > 0) {
          $("#input-number").val(v);
        } else {
          $("#input-number").val(1);
        }
      });
      $("#add-btn").bind("click", function() {
        var v = $("#input-number").val();
        v = parseInt(v) + 1;
        if (v < 99) {
          $("#input-number").val(v);
        } else {
          $("#input-number").val(99);
        }
      });
      var that = this;
      $("#inCart").on("click", function() {
        if (that.$store.state.isLogin) {
          var formData = {
            mobile: that.$cookies.get("user"),
            token: that.$cookies.get("token"),
            id: id,
            number: $("#input-number").val()
          };
          var tableData = that.tableData;
          for (var i in tableData) {
            if (tableData[i].id == id) {
              formData.shop_id = tableData[i].shop_id;
            }
          }
          that.axios
            .get(that.serve + "/member/add_car", {
              params: formData
            })
            .then(res => {
              if (res.data.status == "success") {
                that.$message("商品已加入购物车");
              } else {
                that.$message.error(res.data.msg);
              }
            });
        } else {
          that.$router.push("/login");
        }
      });
      $("#buyNow").bind("click", this.buyNow);
    },
    buyNow() {
      var cartItem = _.find(this.tableData, { id: this.cartId });
      var query = [
        {
          p_id: cartItem.id,
          title: cartItem.title,
          number: $("#input-number").val(),
          price: cartItem.selling_price,
          item_no: cartItem.item_no,
          images: cartItem.images
        }
      ];
      // this.$router.push({
      //   path: '/user/order3',
      //   query: { cart: JSON.stringify(query) }
      // })
      var newJson = {
        p_id: cartItem.id,
        number: $("#input-number").val()
      };
      this.$router.push({
        path: "/user/order4",
        query: newJson
      });
    },
    inCart() {
      this.inCartDialog = true;
    },
    setClass3(v) {
      this.class_name3 = v;
      this.brand = null;
      this.loadData();
    },
    getClass3(v) {
      this.class_name2 = v;
      this.class_name3 = null;
      this.axios
        .get(this.serve + "/third_class", {
          params: {
            class_id: v
          }
        })
        .then(res => {
          this.thirdClass = res.data.data;
        });

      this.loadData();
    },
    handleClick(v) {
      this.suolabel = v.label;
      this.tableType = v.index;
      this.class_name1 = v.index;
      this.class_name2 = null;
      this.class_name3 = null;
      this.loadData1();
      var json = {
        keywords: this.keywords,
        top_class: v.index,
        brand: this.brand,
        leadtime: this.vId
      };
      this.axios
        .get(this.serve + "/second_class", {
          params: json
        })
        .then(res => {
          this.secondClass = res.data.data;
        });
    },
    initData() {
      var query = this.$route.query;
      var q = _.keys(query)[0];
      var v = _.values(query)[0];
      if (q == "topClass") {
        this.class_name1 = v;
      } else if (q == "SecondClass") {
        this.class_name2 = v;
      } else if (q == "ThirdClass") {
        this.class_name3 = v;
      }
      this.loadData();

      this.axios.get(this.serve + "/get_category").then(res => {
        this.categorys = res.data;
      });
    },
    setV(v) {
      this.validity = v;
      this.loadData();
    },

    close() {
      this.keywords = null;
      this.loadData();
    },
    setBand(name) {
      this.brand = name;
      this.loadData();
    },
    pageChange(page) {
      this.curretnPage = page;
      this.loadData();
    },
    loadData() {
      this.ready = false;
      if (this.validity == null) {
        var v = null;
      } else {
        var v = _.indexOf(this.vArray, this.validity);
      }
      this.vId = v;
      var json = {
        keywords: this.keywords,
        orderBy: this.orderBy,
        page: this.curretnPage,
        topClass: this.class_name1 == null ? null : this.class_name1,
        SecondClass: this.class_name2,
        ThirdClass: this.class_name3,
        brand: this.brand,
        isAvailable: this.is_available,
        discounts: this.is_special,
        leadtime: v
      };
      this.axios
        .get(this.serve + "/search", {
          params: json
        })
        .then(res => {
          this.activeClass = res.data.type.toString();
          this.tableData = res.data.results;
          this.count_number = 0;
          for (var count of res.data.cate_count) {
            this.count_number = parseInt(count.number) + this.count_number;
          }
          this.geting(res.data.results.length);
          this.total = res.data.total;
          this.allCount = res.data.cate_count;
          this.tableType = res.data.type;
          for (var i = 0; i < this.allCount.length; i++) {
            if (i == 4 || i == 7) {
              this.topCount[4] =
                this.allCount[4].number + this.allCount[7].number;
            } else if (i > 7) {
              this.topCount[i - 1] = this.allCount[i].number;
            } else {
              this.topCount[i] = this.allCount[i].number;
            }
          }
          this.allBrands = res.data.brand;
          if (this.b_value == null) {
            this.currentBrands = this.allBrands;
          } else {
            this.currentBrands = _.filter(this.allBrands, {
              firstChar: this.b_value
            });
          }
          this.ready = true;
          this.showMore = false;
        });
    },
    loadData1() {
      this.ready = false;
      if (this.validity == null) {
        var v = null;
      } else {
        var v = _.indexOf(this.vArray, this.validity);
      }
      this.vId = v;
      var json = {
        keywords: this.keywords,
        orderBy: this.orderBy,
        page: this.curretnPage,
        topClass: this.class_name1 == null ? null : this.class_name1,
        SecondClass: this.class_name2,
        ThirdClass: this.class_name3,
        brand: this.brand,
        isAvailable: this.is_available,
        discounts: this.is_special,
        leadtime: v
      };
      this.axios
        .get(this.serve + "/search", {
          params: json
        })
        .then(res => {
          this.count_number = 0;
          for (var count of res.data.cate_count) {
            this.count_number = parseInt(count.number) + this.count_number;
          }
          this.tableData = res.data.results;
          this.geting(res.data.results.length);
          this.total = res.data.total;
          this.allCount = res.data.cate_count;
          this.tableType = res.data.type;
          for (var i = 0; i < this.allCount.length; i++) {
            if (i == 4 || i == 7) {
              this.topCount[4] =
                this.allCount[4].number + this.allCount[7].number;
            } else if (i > 7) {
              this.topCount[i - 1] = this.allCount[i].number;
            } else {
              this.topCount[i] = this.allCount[i].number;
            }
          }
          this.allBrands = res.data.brand;
          if (this.b_value == null) {
            this.currentBrands = this.allBrands;
          } else {
            this.currentBrands = _.filter(this.allBrands, {
              firstChar: this.b_value
            });
          }
          this.ready = true;
          this.showMore = false;
        });
    },
    set1(id, name) {
      this.c_id1 = id;
      this.class_name1 = name;
      this.class_name2 = null;
      this.class_name3 = null;
      this.c_id2 = 0;
      this.c_id3 = null;
      for (var item of this.categorys) {
        if (item.id == id) {
          this.categorys2 = item.data;
        }
      }
      this.loadData();
    },
    set2(id, name) {
      this.c_id2 = id;
      this.class_name2 = name;
      this.class_name3 = null;
      this.c_id3 = 0;
      for (var item of this.categorys2) {
        if (item.id == id) {
          this.categorys3 = item.data;
        }
      }
      this.loadData();
    },
    set3(id, name) {
      this.class_name3 = name;
      this.c_id3 = id;
      this.loadData();
    },
    getBrands(v) {
      this.b_value = v;
      if (v == null) {
        this.currentBrands = this.allBrands;
      } else {
        this.currentBrands = _.filter(this.allBrands, { firstChar: v });
      }
    },
    setH() {
      if (this.order_h == 1) {
        this.order_h = 0;
      } else {
        this.order_h = 1;
        this.order_p = null;
      }
      this.loadData();
    },
    setP() {
      if (this.order_p == 1) {
        this.order_p = 2;
      } else {
        this.order_p = 1;
      }
      this.order_h = 0;
      this.loadData();
    }
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.el-tabs__item {
  color: red;
}
#results {
  .hover_class:hover {
    color: rgb(46, 172, 255);
  }
  .imghvr-fade {
    margin-bottom: -2px;
  }
  .moreLink:hover {
    color: #e2211c;
  }
  .tTitle:hover {
    text-decoration: underline;
  }
  .tHeader th {
    text-align: center;
  }
  .viewMore {
    float: left;
    width: 1100px;
    background-color: #f5f5f5;
    padding: 10px 0;
    margin-top: -30px;
  }
  .r1 {
    line-height: 2em;
    padding-top: 30px;
  }
  .bt2 {
    border: 1px solid #999;
    background-color: transparent;
    color: #999;
    padding: 5px 0;
    width: 100px;
    margin-right: 30px;
    cursor: pointer;
    border-radius: 5px;
  }
  .bt2:hover {
    border: 1px solid #e2211c;
    color: #e2211c;
  }
  .bt1 {
    background-color: #fff;
    border: 1px solid #ddd;
    line-height: 22px;
  }
  .row-op {
    background-color: #f5f5f5;
    height: 120px;
    width: 1100px;
    position: relative;
    display: block;
    text-align: center;
    .l1 {
      line-height: 120px;
    }
  }
  .buy-btn:hover span {
    color: #e2211c;
  }
  .el-tabs__item {
    font-weight: bold;
  }
  .empty {
    line-height: 42px;
  }
  .class1 {
    // border-bottom: 1px solid rgb(221, 221, 221);
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      position: relative;
      top: -8px;
    }
  }
  .tab {
    .el-tabs__item {
      line-height: 25px;
      height: 25px;
      padding: 0 10px;
    }
  }
  .c1-box {
    position: relative;
    float: left;
    background-color: #fff;
    border-top: 1px solid #e2211c;
    border-bottom: 1px solid #e2211c;
    width: 800px;
    padding: 5px 10px;
    top: -13px;
  }
  .bd1 {
    border: 1px solid #ddd;
    padding: 2px 8px !important;
    position: relative;
  }
  .hide {
    display: none !important;
  }
  .bCover {
    width: 100px;
    height: 50px;
    border: 1px solid #ddd;
  }
  .bCover:hover,
  .bCover.active {
    border: 1px solid #e2211c;
  }
  .dis2 {
    .rectangle_title {
      // line-height: 10px;
      height: 34px;
      overflow: hidden;
      display: inline-block;
    }
    .rectangle_title:hover {
      color: #e2211c;
    }
    .item {
      border: 1px solid #ddd;
      margin-bottom: 30px;
      text-align: center;
      .price {
        color: #e2211c;
        padding: 10px 20px 5px 20px;
        font-size: 16px;
      }
      .title {
        padding: 5px 20px 10px 20px;
        font-size: 16px;
      }
    }
  }
  .s {
    position: relative;
    top: 5px;
  }
  padding-bottom: 40px;
  .el-table--border th {
    background-color: #eaedf1;
    color: #333;
    font-weight: normal;
  }
  .options {
    padding: 20px 0;
    .btn1.active {
      background-color: #e2211c;
      color: #fff;
    }
  }
  .box1 {
    display: flex;
    justify-content: space-between;
    .none_shop {
      padding: 50px 0;
      display: flex;
      justify-content: flex-end;
      .none_btn {
        margin-bottom: 30px;
      }
      .none_editor {
        width: 270px;
        height: 270px;
        > div {
          float: left;
          margin-left: 5px;
          margin-top: 5px;
          width: 130px;
          height: 130px;
        }
      }
    }
  }
  .box {
    background-color: #fff;
    .box_right_AD {
      height: 90%;
      border: 1px solid rgba(221, 221, 221, 1);
      width: 150px;
      background: rgba(255, 255, 255, 1);
      .right_AD_top {
        width: 100%;
        display: flex;
        justify-content: space-around;
        padding-top: 10px;
        margin-bottom: 30px;
        :nth-child(1) {
          font-size: 12px;
          font-family: "MicrosoftYaHei";
          font-weight: 900;
          color: rgba(51, 51, 51, 1);
        }
        :nth-child(2) {
          font-size: 10px;
          font-family: "MicrosoftYaHeiLight";
          font-weight: 300;
          color: rgba(153, 153, 153, 1);
        }
      }
      .right_AD_conter {
        // background: #999;

        width: 120px;
        margin: 0 auto;
        .right_AD_img {
          width: 120px;
          height: 120px;
        }
        .right_AD_money {
          line-height: 6px;
          font-size: 12px;
          font-family: "MicrosoftYaHei";
          font-weight: 400;
          color: rgba(246, 78, 98, 1);
          padding-left: 6px;
        }
        .right_AD_money1 {
          line-height: 18px;
          font-size: 12px;
          font-family: "MicrosoftYaHei";
          font-weight: 400;
          padding-left: 6px;
          cursor: pointer;
        }
        .right_AD_money1:hover {
          color: rgba(246, 78, 98, 1);
        }
        .right_AD_evaluate {
          padding-left: 6px;
          font-size: 12px;
          font-family: "MicrosoftYaHei";
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }
    }
  }
  .title1 {
    padding: 15px 20px;
    color: #999;
    // display: inline-block;
    width: 70px;
  }
  .title2 {
    margin: 15px 20px;
    color: #999;
    display: inline-block;
    width: 70px;
  }
  .item1 {
    margin-bottom: -11px;
    display: inline-block;
    cursor: pointer;
    color: #666;
    position: relative;
  }
  .item1.active {
    span {
      color: #e2211c;
    }
    color: #e2211c;
    border-color: #e2211c;
    border-bottom: 1px solid #fff;
    z-index: 999;
  }
  .item1:hover,
  .el-tabs__item.is-top.is-active,
  .item1.active2 {
    color: #e2211c;
  }
  .under-line {
    span,
    .el-tabs__item {
      color: #005288;
    }
  }
}
</style>